function _validateNIF(nif) {
  const nifPattern = /^[0-9XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/i
  return nifPattern.test(nif)
}

$(function () {
  function renderProvinceOptions() {
    $('.js-address-provinces option').each((index, item) => {
      const provincesRaw = $(item).attr('data-provinces')
      const form = $(item).parents('form')
      const defaultLocation = form.find('select').attr('data-default')
      const selector = form.find('select')

      let provinces = provincesRaw.replace(/'/g, '"')
      provinces = JSON.parse(provinces)

      provinces.forEach(element => {
        const option = $('<option>').val(element[0]).text(element[1])

        if (element[0] === defaultLocation) {
          option.attr('selected', 'selected')
        }

        selector.append(option)
      })
    })
  }

  function selectAddressToEdit() {
    $('.js-address__provinces-edit').on('click', function () {
      const id = $(this).data('id')
      const form = $(`.js-address-form[data-id=${id}]`)

      $('.js-address-form').hide()
      form.show()

      $('html, body').animate({ scrollTop: 0 }, 0)
      $('.js-address-provinces').remove()
    })
  }

  function generateInvoice() {
    function downloadInvoice(orderId) {
      let link = document.createElement('a')
      link.href = `/apps/natuka-app/invoices/${orderId}`
      link.style.display = 'none'

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    $('.js-order__generate-invoice').on('click', function () {
      $('.js-gen-invoice__modal').show()

      const nif = $(this).data('nif')
      const orderId = $(this).data('order-id')

      if (nif) {
        $('.js-gen-invoice__input-nif').val(nif)
      }

      $('.js-gen__submit').attr({ 'data-order-id': orderId })
    })

    $('.js-gen__submit').on('click', function () {
      $(this).addClass('btn--loading')
      const orderId = $(this).data('order-id')
      const nif = $('.js-gen-invoice__input-nif').val()
      const warningLayer = $('.js-gen-invoice__input-warning')
      const errorLayer = $('.js-gen-invoice__input-error')

      if (!nif || !_validateNIF(nif)) {
        warningLayer.show()
        $(this).removeClass('btn--loading')
        return
      } else {
        warningLayer.hide()
      }

      const updates = {
        nif,
      }

      fetch(`${window.Shopify.routes.root}apps/natuka-app/invoices/${orderId}/make-nominative`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updates),
      })
        .then(data => {
          if (data.error === 'not_same_quarter') {
            errorLayer.text('La factura no se puede generar. El trimestre ha caducado.')
          } else {
            errorLayer.text('')
            downloadInvoice(orderId)
            $(this).removeClass('btn--loading')
            $('.js-gen-invoice__modal').hide()
          }
        })
        .catch(error => console.error('Error downloading PDF file:', error))
    })

    $('.js-gen__close-modal').on('click', function () {
      $('.js-gen-invoice__modal').hide()
    })
  }
  
  renderProvinceOptions()
  selectAddressToEdit()
  generateInvoice()
})
